const searchDataRemote = {
  state: {
    searchData: ""
  },
  mutations: {
    SEARCHDATAREMOTE(state, params) {
      state.searchData = params;
    }
  },
  actions: {
    searchDataRemote({ commit }, params) {
      commit("SEARCHDATAREMOTE", params);
      console.log(params,99);
    }
  }
};


export default searchDataRemote;



// WEBPACK FOOTER //
// ./src/store/modules/searchDataRemote.js